import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {Intercalaire} from '../_models';
import {LexiboxImage} from '../_models/lexiboxImage';
import {first} from 'rxjs/operators';
import {LexiboxService} from '../_services/lexibox.service';
import {config} from '../../assets/config';
import {BaseModalComponent} from '../base-modal/base-modal.component';
import {CreateLexiboxComponent} from '../modals/create-lexibox/create-lexibox.component';
import {Router} from '@angular/router';
import {getCurrentAbeille, getCurrentRole} from '../../assets/utils.js';

@Component({
  selector: 'app-lexibox',
  templateUrl: './lexibox.component.html',
  styleUrls: ['./lexibox.component.scss']
})
export class LexiboxComponent implements OnInit {

    @ViewChild('modal', {static: false}) modal: CreateLexiboxComponent;
    @ViewChild('search', {static: true}) searchField: ElementRef;

    images: LexiboxImage[] = [];
    sortedImages: LexiboxImage[] = [];
    apiUrl = config.apiUrl;
    patientId = '';
    currentRole = '';

    checkedImages = [];
    showActionButton = false;
    showInfo = false;

    showModal = false;


    constructor(private router: Router, private lexiboxService: LexiboxService) {
        if (!getCurrentAbeille()) {
            this.router.navigate(['/dashboard']);
        }

        this.patientId = getCurrentAbeille().id;
        this.currentRole = getCurrentRole();
        this.refreshList();
    }

    ngOnInit() {
    }

    public refreshList() {
        this.lexiboxService.getByPatientId(this.patientId).pipe(first()).subscribe(images => {
            this.images = this.sortedImages = images as LexiboxImage[];
        });
        this.showModal = false;
    }

    public addImage() {
        this.modal.clickFileInput();
        this.showModal = !this.showModal;
    }

    searchImages() {
        const search = this.searchField.nativeElement.value.toLowerCase();

        this.sortedImages = [];
        this.images.forEach((image) => {
            if (image.name.toLowerCase().indexOf(search) > -1) {
                this.sortedImages.push(image);
            }
        });

    }

    checkImage(id) {
        let index = this.checkedImages.indexOf(id);

        if (index > -1) {
            this.checkedImages.splice(index, 1);
        } else {
            this.checkedImages.push(id);
        }

        this.showActionButton = this.checkedImages.length > 0;
    }

    deleteImages() {

        const promises = [];

        this.checkedImages.forEach((imageId) => {
            promises.push(this.lexiboxService.delete(imageId).pipe(first()).subscribe());
        });

        Promise.all(promises).then((results) => {
            this.refreshList();
            this.showActionButton = false;
        });
    }
}
